(function() {
  function updateBlogTabsGradient() {
    const wrapper = document.querySelector('.blog-tabs__wrapper');
    const list = document.querySelector('.blog-tabs__list');
    
    if (!wrapper || !list) return;
    
    const isScrollable = list.scrollWidth > list.clientWidth;
    const isScrolled = list.scrollLeft < (list.scrollWidth - list.clientWidth - 1);
    
    wrapper.classList.toggle('scrollable', isScrollable);
    wrapper.classList.toggle('scrolled', isScrolled);
  }
  
  function setupBlogTabsListeners() {
    const list = document.querySelector('.blog-tabs__list');
    if (list) {
      list.removeEventListener('scroll', updateBlogTabsGradient);
      list.addEventListener('scroll', updateBlogTabsGradient);
      updateBlogTabsGradient();
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupBlogTabsListeners);
  } else {
    setupBlogTabsListeners();
  }
  
  window.addEventListener('resize', updateBlogTabsGradient);
  
  const observer = new MutationObserver(() => {
    setupBlogTabsListeners();
  });
  
  const blogPostsList = document.querySelector('blog-posts-list');
  if (blogPostsList) {
    observer.observe(blogPostsList, {
      childList: true,
      subtree: true,
    });
  }
})();

